import { isLoading, loading } from "../Loading";
import { AppState } from "../system/AppState";
import useMixin from "./useMixin";

const useCaregiver = (appState: AppState) => {
  const { appCaregiverState } = useMixin(appState);

  if (isLoading(appCaregiverState)) {
    return loading();
  }

  return appCaregiverState.caregiver;
};

export default useCaregiver;
